import { useEffect } from 'react';
import { createPreference, usePreference } from '../preferences/storedPreference';
import {
  applyThemePreference,
  readStoredThemeAccent,
  readStoredThemeMode,
  storeThemeAccent,
  storeThemeMode,
  type ThemeAccent,
  type ThemeMode
} from './themePreference';

// #502 (ADR 0012) -- index.html's inline pre-paint script already applied whatever was stored
// before this (or React) ever mounts, so there's no flash of the wrong theme to fix here; this
// hook's job is just to read that same persisted state into React, and keep the DOM attributes +
// localStorage in sync whenever the user changes it.
//
// #928: the mode and accent are shared stores, so every control showing them -- the account
// menu's Appearance and the Monograph's theme button -- reflects a change at once.
export const themeModePreference = createPreference<ThemeMode>({
  key: 'peruselab.theme.mode',
  read: readStoredThemeMode,
  write: storeThemeMode
});

export const themeAccentPreference = createPreference<ThemeAccent>({
  key: 'peruselab.theme.accent',
  read: readStoredThemeAccent,
  write: storeThemeAccent
});

export function useThemePreference() {
  const mode = usePreference(themeModePreference);
  const accent = usePreference(themeAccentPreference);

  useEffect(() => {
    applyThemePreference(mode, accent);
  }, [mode, accent]);

  return { mode, accent, setMode: themeModePreference.set, setAccent: themeAccentPreference.set };
}
